<script setup lang="ts">
import { computed } from "vue";
import { usePosts } from "@/blog/use-posts";
import { useBlogIndexSeoHead } from "@/composables/use-blog-seo-head";
import { blogPostPath, DEFAULT_LOCALE, pathFor } from "@/seo/routes-manifest";

useBlogIndexSeoHead();

const posts = usePosts();
const isEmpty = computed(() => posts.length === 0);
const homePath = pathFor("home", DEFAULT_LOCALE);
</script>

<template>
  <main class="blog-index">
    <div class="blog-index__inner">
      <header class="blog-index__header">
        <h1 class="blog-index__title">Blog</h1>
        <p class="blog-index__dek">Essays on raising kids with rhythm.</p>
      </header>

      <section v-if="isEmpty" class="blog-index__empty">
        <h2 class="blog-index__empty-title">Essays coming soon.</h2>
        <p class="blog-index__empty-body">
          We're publishing our first piece on raising kids with rhythm. Check back soon.
        </p>
        <router-link :to="homePath" class="blog-index__empty-back blog-post__back">
          <UIcon name="i-lucide-arrow-left" class="size-4" />
          Back to home
        </router-link>
      </section>

      <ul v-else role="list" class="blog-index__list">
        <li v-for="post in posts" :key="post.id">
          <router-link :to="blogPostPath(post.slug)" class="blog-card">
            <h2 class="blog-card__title">{{ post.title }}</h2>
            <p class="blog-card__meta">
              <time :datetime="post.publishDate">{{ post.publishDateDisplay }}</time>
              · {{ post.readTimeMinutes }} min read
            </p>
            <p class="blog-card__lede">{{ post.lede }}</p>
          </router-link>
        </li>
      </ul>
    </div>
  </main>
</template>
